import { GenerateIncidentSummaryMutation } from '@/graphql/generated/operations'
import { AiIncidentSeverityCategory } from '@/graphql/generated/schemas'

export type SummaryPayload =
  GenerateIncidentSummaryMutation['generateIncidentSummary']

export interface SummarizeIncidentsModalIProps {
  incidents: Array<{ id: string; displayId: string }>
  isOpen: boolean
  onClose: () => void
}

export const CATEGORY_LABEL_KEYS = {
  [AiIncidentSeverityCategory.Critical]: 'incidents:summary_category_critical',
  [AiIncidentSeverityCategory.Urgent]: 'incidents:summary_category_urgent',
  [AiIncidentSeverityCategory.Moderate]: 'incidents:summary_category_moderate',
  [AiIncidentSeverityCategory.Low]: 'incidents:summary_category_low',
  [AiIncidentSeverityCategory.Informational]:
    'incidents:summary_category_informational',
} as const satisfies Record<AiIncidentSeverityCategory, string>

/**
 * The `severityBreakdown` payload keys are camelCase counters; they are mapped explicitly rather
 * than upper-cased and cast, so a field the backend adds later cannot silently become a
 * non-member of the enum.
 */
export const SEVERITY_FIELD_TO_CATEGORY: Record<
  string,
  AiIncidentSeverityCategory
> = {
  critical: AiIncidentSeverityCategory.Critical,
  urgent: AiIncidentSeverityCategory.Urgent,
  moderate: AiIncidentSeverityCategory.Moderate,
  low: AiIncidentSeverityCategory.Low,
  informational: AiIncidentSeverityCategory.Informational,
}
